import React, { useEffect, useRef } from "react";
import "./Explore_By_Category.css";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import Explore_Category_Card from "./explore_category_card/Explore_Category_Card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import "swiper/css";
import "swiper/css/grid";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Autoplay } from "swiper/modules";
import useIsMobile from "./useIsMobile";

const Explore_By_Category = (props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const categories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  // const grouped = [];
  // for (let i = 0; i < categories.slice(2).length; i += 2) {
  //   grouped.push(categories.slice(2).slice(i, i + 2));
  // }

  // // Ref for horizontal scroll
  // const scrollRef = useRef(null);

  // const scroll = (direction) => {
  //   if (scrollRef.current) {
  //     const scrollAmount = 250; // adjust as needed
  //     scrollRef.current.scrollBy({
  //       left: direction === "left" ? -scrollAmount : scrollAmount,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  // // Swiper reference
  // const isMobile = useIsMobile();
  return (
    <section className="Explore_By_Category">
      <Common_Heading_Holder headingText={"Explore by Category"} />

      <div className="white_card_div">
        <div className="row me-0 ms-0 ">
          <>
            {categories?.map((val) => (
              <div
                className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-5"
                // onClick={() => {
                //   props?.setCategoryId(categories[0]?.id);
                // }}
              >
                <Explore_Category_Card
                  data={val}
                  id={val?.id}
                  img={val?.image}
                  product={val?.name}
                  goto={"/shop"}
                />
              </div>
            ))}
            {/* <div
                   className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-5"
                  onClick={() => {
                    props?.setCategoryId(categories[0]?.id);
                  }}
                >
                  <Explore_Category_Card
                    data={categories[1]}
                    id={categories[1]?.id}
                    img={categories[1]?.image}
                    product={categories[1]?.name}
                  />
                </div> */}
          </>
        </div>
      </div>
    </section>
  );
};

export default Explore_By_Category;
